import React from 'react';
import './styles.css';

/**
 * The choice a workspace opens on: have it generated, or edit it yourself.
 *
 * Shown where the decision actually is — an Edit step with nothing in it yet —
 * rather than at project creation, because both paths fill the same workspace
 * and the choice stays reversible. A generated video lands as ordinary assets,
 * so "generate" is a way to get footage, not a separate kind of project.
 */
function GenerationFork({ onGenerate, onUpload, hasScript, disabled, resumeStage }) {
    const resuming = Boolean(resumeStage);

    return (
        <div className="gen-fork-wrap">
            <h3 className="gen-fork-intro">
                {resuming ? 'You have a generation in progress' : 'How do you want to make this video?'}
            </h3>

            <div className="gen-fork">
                <div className="gen-fork-card">
                    <h4>Generate it</h4>
                    <p>
                        {hasScript
                            ? 'Turn the script from your idea into shots and a finished cut. You approve how the characters look before anything is rendered.'
                            : 'Write or paste a script and turn it into shots and a finished cut. You approve how the characters look before anything is rendered.'}
                    </p>
                    <span className="gen-fork-meta">A few minutes · billed per second of video</span>
                    <button type="button" className="gen-btn gen-btn-primary" onClick={onGenerate} disabled={disabled}>
                        {resuming ? 'Pick up where you left off' : 'Generate the video'}
                    </button>
                </div>

                <div className="gen-fork-card">
                    <h4>Edit it myself</h4>
                    <p>
                        Bring your own clips, images and audio, then cut them with effect blocks
                        or the AI editor.
                    </p>
                    <span className="gen-fork-meta">Free to start · you supply the media</span>
                    <button type="button" className="gen-btn" onClick={onUpload} disabled={disabled}>
                        Add media
                    </button>
                </div>
            </div>

            <p className="gen-fork-note">
                Not a one-way door — generated shots arrive as normal assets, so you can keep editing after.
            </p>
        </div>
    );
}

export { GenerationFork };
